exports = module.exports = require("../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#home-restaurant-details {\n\tmargin-top: 3em;\n      margin-bottom:2em;\n}\n\n#home-restaurant-details > div {\n\t//margin-bottom: 2em;\n\ttext-align: center;\n}\n\n#home-restaurant-details > div > h3 {\n\tmargin-bottom: 1em;\n}\n/* .thetitle {\n\tfont-weight: 700;\n\tfont-size:32px;\n\tfont-family: \"Fredoka One\";\n\tcolor: gold;\n        text-align:center;\n        padding-bottom:10px;\n}\n\n.subtitle {\n\tfont-family: \"Dosis\";\n\tfont-size: 18px;\n\tfont-style: oblique;\n\t}\n\nhr.stylespec {\n\tcolor: gold;\n\tbackground-color: gold;\n\tborder-top: 4px double #8c8b8b;\n\ttext-align: center;\n\twidth: 100px;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tmargin-bottom:20px;\n}*/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/home.component.css
// module id = ../../../../../src/app/home.component.css
// module chunks = main